/**
 * A program invitation link (/join/<code>) a student opened before they could
 * use it: logged out, or still finishing signup. The code is kept for this tab
 * so it survives logging in and the onboarding steps, then offered once on
 * My Coaching → Programs (the way team apps bring you back to an invite).
 */
const KEY = "pendingProgramCode";
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function savePendingJoin(code) {
    try {
        sessionStorage.setItem(KEY, JSON.stringify({ code, savedAt: Date.now() }));
    } catch { /* storage blocked: they can still enter the code by hand */ }
}

/** The saved code (and forget it), or null. */
export function takePendingJoin() {
    try {
        const saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
        sessionStorage.removeItem(KEY);
        return saved && saved.code && Date.now() - saved.savedAt < MAX_AGE_MS ? saved.code : null;
    } catch {
        return null;
    }
}

export function clearPendingJoin() {
    try {
        sessionStorage.removeItem(KEY);
    } catch { /* nothing saved */ }
}
